
import {
    Spacer,
    Text
} from '@components/1-atoms';
import ListItem from '@components/2-molecules/ListItem';
import React, { FC } from 'react';
import { View } from 'react-native';

import { PageProps } from '@lib/constants';

type Props = PageProps;

const DocumentMenu: FC<Props> = ({ navigation, onDone, ...props }) => {

    return (
        <View>
            <ListItem
                sub={<Text small color={"#808080"}>{"Create an estime for your customers."}</Text>}
                onPress={() => navigation?.navigate('EstimateCreate', { ...props, onDone })}
            >
                <Text>Create an estime for a customer</Text>
            </ListItem>
            <Spacer h={0.3} />

        </View>
    );
};

export default DocumentMenu;